<template>
  <el-card v-loading="loading" shadow="hover">
    <div style="padding: 10px 20px">
      <div v-if="editModel">
        <el-form
          ref="form"
          :size="$xUISize"
          :model="editModel"
          :rules="editRules"
          @submit.native.prevent
          label-width="auto"
          label-position="top"
        >
          <el-form-item label="渠道名称" prop="name">
            <el-input
              placeholder="请输入渠道名称"
              v-model="editModel.name"
            ></el-input>
          </el-form-item>
          <el-form-item label="简介说明" prop="desc">
            <el-input
              type="textarea"
              v-model="editModel.desc"
              placeholder="请输入简介说明"
              maxlength="256"
              :rows="2"
            ></el-input>
          </el-form-item>
          <el-form-item label="排序编号" prop="optSort">
            <el-input
              type="number"
              v-model="editModel.optSort"
              placeholder="请输入排序编号"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item label="备注说明" prop="optRemark">
            <el-input
              type="textarea"
              v-model="editModel.optRemark"
              :rows="4"
              maxlength="256"
              placeholder="输入备注说明内容"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="editSubmit"
              @submit.native.prevent
              @click="submitClick"
            >
              保存
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
        <el-button v-if="errorMsg" @click="fetchModel" size="small">
          重新加载
        </el-button>
      </el-empty>
    </div>
  </el-card>
</template>

<style lang="less" scoped>
.borderBox {
  border-radius: 4px;
  border: 1px solid #dedede;
  padding: 20px;

  &:hover {
    border: 1px solid #cecece;
  }
}
</style>

<script>
const defaultModel = {
  companyName: "",
  companyAddress: "",
  optStatus: 1
}

export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      editSubmit: false,
      editModel: null,
      editRules: {
        name: [
          {
            required: true,
            message: "请输入渠道名称",
            trigger: "change",
          },
        ],
        desc: [
          {
            required: true,
            message: "请输入渠道说明",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    submitClick() {
      this.$refs.form.validate((valid, data) => {
        if (valid) {
          this.editSubmit = true;
          const method = this.editModel.guid
            ? "biz.customer.outbound.channel.update"
            : "biz.customer.outbound.channel.create";
          this.requestApi(method, this.editModel, {
            showError: true
          }).then((resp) => {
            this.success("保存成功");
            this.$drawer.refreshDrawer();
            this.$drawer.backDrawer();
          }).finally(() => {
            this.editSubmit = false;
          });
        } else {
          this.showValidate(data);
        }
      });
    },
    handleModel() {
      // nothing
      if (this.pageParams.storeGuid) {
        this.editModel.storeGuid = this.pageParams.storeGuid;
      }
    },
    fetchModel() {
      const guid = this.pageParams.guid;
      if (!guid) {
        // 新增
        this.editModel = Object.assign({}, defaultModel);
        this.handleModel();
      } else {
        // 编辑
        this.errorMsg = null;
        this.loading = true;
        this.requestApi("biz.customer.outbound.channel.detail", {
          guid: this.pageParams.guid,
          storeGuid: this.pageParams.storeGuid
        }).then((resp) => {
          this.editModel = resp.data;
          this.handleModel();
        }).catch((err) => {
          this.errorMsg = (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
        }).finally(() => {
          this.loading = false;
        });
      }
    },
  },
  mounted() {
    this.fetchModel();
  },
};
</script>